// components/clients/RelaunchPanel.jsx
import React from 'react';
import { Button, Modal, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

const relaunchMessageFor = (client) => {
  const sizes = client.preferred_sizes?.length
    ? ` dans vos pointures habituelles (${client.preferred_sizes.map((size) => `P${size}`).join(' et ')})`
    : '';
  return [
    `Bonjour ${client.client_name},`,
    `Nous venons de recevoir quelques nouveautés qui pourraient vous plaire${sizes}.`,
    'Nous serions ravis de vous les présenter. Belle journée à vous !',
    'Ndoé Boutique',
  ].join('\n\n');
};

// Suggestion de relance + copie du message (toast si presse-papiers dispo, Modal en repli).
export const RelaunchPanel = ({ client }) => {
  if (!client?.relaunch_candidate) return null;

  const copyRelaunch = async () => {
    const text = relaunchMessageFor(client);
    try {
      await navigator.clipboard.writeText(text);
      message.success('Message de relance copié.');
    } catch (_) {
      Modal.info({
        title: 'Message de relance',
        okText: 'Fermer',
        content: <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{text}</pre>,
      });
    }
  };

  return (
    <section className="mobile-client-relaunch">
      <div>
        <span>RELANCE SUGGÉRÉE</span>
        <strong>{client.relaunch_reason}</strong>
        <p>Le message reste à envoyer manuellement après vérification de la fiche.</p>
      </div>
      <Button icon={<CopyOutlined />} onClick={copyRelaunch}>Copier</Button>
    </section>
  );
};
